module.exports = "/static/img/get_in_touch_header_bg.jpg?9830e109a6ae9ff72c1a12f2fc7d2cb7";